import { type ReactElement, useEffect } from 'react';
import { PageLoader } from 'src/components/PageLoader';
import { useCurrentUser } from 'src/lib/customHooks/useCurrentUser';
import { applyTrackingConsent } from 'src/lib/trackingConsent';
import { useStore } from '../../store/reducers';

type Props = {
  children: ReactElement;
};

export default function UserContext({ children }: Props) {
  const isLoading = useStore((s) => s.users.isLoadingCurrentUser);
  const currentUser = useCurrentUser();
  const analyticsConsent = !!currentUser?.trackingConsent?.analytics;
  const { loadCurrentUser } = useStore((s) => s.users.actions);
  const { loadBrands } = useStore((s) => s.brands.actions);

  useEffect(() => {
    (async () => {
      await loadCurrentUser();
      await loadBrands();
    })();
  }, []);

  useEffect(() => {
    applyTrackingConsent(analyticsConsent);
  }, [analyticsConsent]);

  if (isLoading) return <PageLoader />;

  return children;
}
